import styled from "styled-components";

const sizes = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px", //--breakpoint-sm
  tablet: "768px", //--breakpoint-md
  laptop: "992px", //--breakpoint-lg
  desktop: "1024px",
  desktopM: "1200px", //--breakpoint-xl
  desktopL: "1440px",
  desktopXL: "1920px",
  desktopXXL: "2560px",
};

const devices = {
  mobileS: `(min-width: ${sizes.mobileS})`,
  mobileM: `(min-width: ${sizes.mobileM})`,
  mobileL: `(min-width: ${sizes.mobileL})`,
  tablet: `(min-width: ${sizes.tablet})`,
  laptop: `(min-width: ${sizes.laptop})`,
  desktop: `(min-width: ${sizes.desktop})`,
  desktopM: `(min-width: ${sizes.desktop})`,
  desktopL: `(min-width: ${sizes.desktop})`,
  desktopXL: `(min-width: ${sizes.desktop})`,
  desktopXXL: `(min-width: ${sizes.desktop})`,
};

export const CustomersSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgb(255, 255, 255);
  width: 100%;
  text-align: center;
  padding-top: 8%;
  padding-bottom: 10%;

  @media ${devices.mobileS} {
    padding-left: 15px;
    padding-right: 15px;

    padding-top: 100px;
    padding-bottom: 5%;
  }

  @media ${devices.mobileM} {
    padding-left: 15px;
    padding-right: 15px;

    padding-top: 100px;
    padding-bottom: 5%;
  }

  @media ${devices.mobileL} {
    padding-left: 22.75px;
    padding-right: 22.75px;
  }

  @media (min-width: 549px) {
    padding-left: 60px;
    padding-right: 60px;
  }

  @media ${devices.tablet} {
    padding-left: 120px;
    padding-right: 120px;

    padding-top: 70px;
    padding-bottom: 5%;
  }

  /* @media ${devices.laptop} {
    padding-top: 8%;
    padding-bottom: 10%;
  } */

  @media ${devices.desktop} {
    padding-left: 140px;
    padding-right: 140px;
  }

  @media ${devices.desktopL} {
    padding-left: 140px;
    padding-right: 140px;
  }

  @media ${devices.desktopXL} {
    padding-top: 70px;
    padding-bottom: 140px;
  }

  @media ${devices.desktopXXL} {
    padding-top: 70px;
    padding-bottom: 140px;
  }
`;

export const CurtomersHeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const CustomersTitle = styled.h1`
  display: flex;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  width: 100%;
  text-align: center;

  @media ${devices.mobileS} {
    text-align: left !important;
  }

  @media ${devices.tablet} {
    text-align: center !important;
  }

  @media ${devices.desktopL} {
    text-align: center !important;
    justify-content: center;
  }
`;

export const CustomersText = styled.span`
  display: flex;
  width: 100%;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 300;

  text-align: center;

  @media ${devices.mobileS} {
    text-align: left !important;
  }

  @media ${devices.tablet} {
    text-align: center !important;
  }

  @media ${devices.desktopL} {
    text-align: center !important;
    justify-content: center;
  }
`;

export const CustomersCarouselSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 30px;
  overflow: hidden;
`;

export const CustomersCarouselContainer = styled.div`
  margin-top: 30px;
  width: 100%;
  max-width: 1140px;
    
  .slick-dots li {
    height: 0px;
  }

  .slick-active #indicator {
    background-color: #0096d5;
    height: 10px;
  }
`;

export const CustomersCarouselImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 200px;
  padding: 15px;

  @media ${devices.mobileS} {
    max-width: 60%;
  }

  @media ${devices.mobileM} {
    max-width: 60%;
  }

  @media ${devices.mobileL} {
    max-width: 60%;
  }

  @media ${devices.tablet} {
    max-width: 150px;
  }

  @media ${devices.desktopL} {
    max-width: 150px;
  }

  @media ${devices.desktopXL} {
    max-width: 200px;
  }

  @media ${devices.desktopXXL} {
    max-width: 250px;
  }
`;

export const CustomersCarouselImage = styled.img`
  width: 100%;
`;
